import Snackbar from '@/components/elements/notifications/Snackbar/Snackbar';
import { _t } from '@/locale';
import type { TranslationKey, TranslationMap } from '@/locale/translation-map';
import { toast, ToastOptions } from 'react-toastify';

type StringTranslationKey = {
  [K in TranslationKey]: TranslationMap[K] extends string ? K : never;
}[TranslationKey];

export function showGeolocationErrorToast(
  error: GeolocationPositionError,
  options?: { deniedKey?: StringTranslationKey; autoClose?: ToastOptions['autoClose'] },
) {
  const defaultDeniedKey = 'locationPermissionError';
  let label: string;

  if (error.code === GeolocationPositionError.PERMISSION_DENIED) {
    label = _t(options?.deniedKey ?? defaultDeniedKey);
  } else {
    label = _t('locationFetchError');
  }

  toast(({ closeToast }) => <Snackbar label={label} onClose={closeToast} />, { autoClose: options?.autoClose });
}
